import React from 'react';
import { Navbar } from 'react-bootstrap';
import Logo from './Logo';

export default function Header({
  isHost = false,
  roomID = null,
  canEndGame = false,
  onEndGame = null,
  canRestart = false,
  onRestart = null,
}) {
  return (
    <header>
      <Navbar>
        <Navbar.Brand>
          <Logo /> Menbirinchi
        </Navbar.Brand>
        {isHost ? (
          <div className="nav-host-meta">
            <div className="nav-host-row">
              {roomID ? (
                <span className="nav-room" title="Jamoalarga shu kodni bering">
                  Xona <strong>{roomID}</strong>
                </span>
              ) : null}
              {canRestart && onRestart ? (
                <button
                  type="button"
                  className="nav-restart-btn"
                  onClick={onRestart}
                  title="Jamoalar saqlanadi, ballar noldan"
                >
                  Qayta boshlash
                </button>
              ) : null}
              {canEndGame && onEndGame ? (
                <button type="button" className="end-game-link" onClick={onEndGame}>
                  Yakunlash
                </button>
              ) : null}
            </div>
          </div>
        ) : null}
      </Navbar>
    </header>
  );
}
